<script setup lang="ts">
  import { onMounted, provide } from 'vue'
  import { useUser } from '@gat-ship/user'
  import {
    supportSessionAssignedKey,
    useSupportSessionAssigned
  } from '../../composables/useSupportSessionAssigned'

  // App-root owner of the assigned-sessions service. Must be mounted
  // below AppInitialization, which only renders its subtree once the
  // user profile is loaded — so `isSupportUser` is settled when this
  // setup runs and the provide can be genuinely conditional: non-Gatship
  // users never get the key, and `useSupportSessionAssignedContext()`
  // returns undefined for them.
  const user = useUser()

  const supportSessionAssignedService = user.isSupportUser.value
    ? useSupportSessionAssigned()
    : undefined

  if (supportSessionAssignedService) {
    provide(supportSessionAssignedKey, supportSessionAssignedService)
  }

  onMounted(() => {
    // The initial fetch also subscribes to the support-session SignalR
    // events, which keep the list — and the sidebar badge derived from
    // it — current for the rest of the session.
    supportSessionAssignedService?.assignedSessionsDataSource.fetchData()
  })
</script>

<template>
  <slot />
</template>
